import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboNombreGrupoVerracoActiva`, method: 'GET', body: null, token: token})
}